import type { AssetId, OutlookSpaceAssetId } from 'owa-timestream-types';

/** A map between client-generated asset IDs and the server generated value (or its promise). */
export default new Map<AssetId, OutlookSpaceAssetId | Promise<OutlookSpaceAssetId | null>>();
